module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [(_vm.user.avatar_url) ? _c('v-avatar', {
    staticClass: "mr-2",
    attrs: {
      "size": "32px"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.user.avatar_url + '&s=30',
      "aspect-ratio": "1"
    }
  })], 1) : [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-account-circle")])], _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [(_vm.user.first_name) ? [_vm._v("\n        " + _vm._s(_vm.user.first_name) + "\n      ")] : _vm._e(), _vm._v(" "), _c('v-icon', [_vm._v("arrow_drop_down")])], 2)], 2), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    staticClass: "profile-hint no-wrap"
  }, [_vm._v("\n      " + _vm._s(_vm.user.full_name)), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("moment")(_vm.user.login_at, 'MM/DD/YYYY hh:mm A [PT]z')) + "\n    ")]), _vm._v(" "), _c('v-list-tile', {
    staticClass: "hidden-md-and-up",
    attrs: {
      "to": "/items"
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-format-list-bulleted")]), _vm._v("\n        Items\n      ")], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "hidden-md-and-up",
    attrs: {
      "to": "/orders"
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-format-list-numbered")]), _vm._v("\n        Orders\n      ")], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "hidden-md-and-up"
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": "/account"
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-account")]), _vm._v("\n        Account\n      ")], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "disabled": "",
      "to": ""
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-message-bulleted")]), _vm._v("\n        What's New\n      ")], 1)], 1), _vm._v(" "), (_vm.hasStore) ? _c('v-list-tile', {
    attrs: {
      "href": _vm.storeUrl,
      "target": "_blank"
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-store")]), _vm._v("\n        View Store\n      ")], 1)], 1) : _c('v-list-tile', {
    attrs: {
      "href": "https://www.gungho.com/store",
      "target": "_blank"
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-store")]), _vm._v("\n        Get A Store\n      ")], 1)], 1), _vm._v(" "), (_vm.hasStore) ? _c('v-list-tile', {
    attrs: {
      "href": _vm.storeEditUrl,
      "target": "_blank"
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v("\n        Edit Store\n      ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasStore) ? _c('v-list-tile', {
    attrs: {
      "href": _vm.storeReportUrl,
      "target": "_blank"
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-finance")]), _vm._v("\n        Sales Report\n      ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? [_c('v-divider'), _vm._v(" "), _vm._l((_vm.adminMenu), function(item) {
    return [_c('v-list-tile', {
      attrs: {
        "to": item.href
      }
    }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v(_vm._s(item.icon))]), _vm._v("\n            " + _vm._s(item.text) + "\n          ")], 1)], 1)]
  })] : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "hidden-md-and-up",
    attrs: {
      "target": "_blank",
      "href": _vm.helpUrl
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-help-circle")]), _vm._v("\n        Help\n      ")], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.logoutUrl
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("mdi-logout-variant")]), _vm._v("\n        Log Out\n      ")], 1)], 1)], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f0dad0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/profile-menu.vue
// module id = 797
// module chunks = 1